// La imagen se inserta como HTML y no como `![](...)` porque markdown no
// expresa ni el ancho ni la alineación: con `![](...)` el catálogo la publica
// siempre pegada a la izquierda y a tamaño completo. El HTML usa solo `width`
// y `style` (nada de clases) porque `renderMarkdown()` filtra las clases que no
// estén en su allowlist, y ese mismo HTML lo publican catalog/ y ecommerce/.
export const IMAGE_SIZES = [
    { key: "small", label: "Pequeña", width: 240 },
    { key: "medium", label: "Mediana", width: 420 },
    { key: "large", label: "Grande", width: 640 },
    { key: "full", label: "Completa", width: null },
    { custom: true, key: "custom", label: "Otro ancho", width: null }
];

export const MIN_IMAGE_WIDTH = 40;

export const MAX_IMAGE_WIDTH = 2000;

const ALIGNMENTS = ["left", "center", "right"];

function escapeAttribute(value) {
    return String(value === undefined || value === null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/"/g, "&quot;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");
}

export function buildImageSnippet({ align, alt, link, url, width }) {
    const size =
        Number(width) > 0
            ? ` width="${Math.round(width)}"`
            : ' style="width:100%"';
    const image =
        `<img src="${escapeAttribute(url)}" alt="${escapeAttribute(alt)}"` +
        `${size}>`;
    const content = link
        ? `<a href="${escapeAttribute(
              link
          )}" target="_blank" rel="noopener noreferrer">${image}</a>`
        : image;
    const alignment = ALIGNMENTS.includes(align) ? align : "left";

    return {
        block: true,
        text: `<p style="text-align:${alignment}">${content}</p>`
    };
}
